export default __webpack_public_path__ + "static/media/rosepic-cover.1495ee2d.jpg";